import { useState } from 'react'

import { StripeCheckoutSessionClient } from 'api/clients/StripeCheckoutSessionClient'
import { stripePromise } from 'components/UpdatePaymentMethodModal/UpdatePaymentMethodModal'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { HeapEventType, trackEventInHeap } from 'utils/heapTracking'
import { reportError } from 'utils/error'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'

export const useStripePaymentMethodUpdate = (success_url?: string, cancel_url?: string) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const workspaceId = useCurrentWorkspaceId()

  const redirectToStripe = async () => {
    setIsProcessing(true)
    const res = await StripeCheckoutSessionClient.create(workspaceId, success_url, cancel_url)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const stripe = await stripePromise

      if (!stripe) {
        setIsProcessing(false)
        showErrorMessageToast('Unable to contact payment provider')
        return
      }

      trackEventInHeap(HeapEventType.UpdatePaymentMethod, { action: 'start' })

      const { error } = await stripe.redirectToCheckout({
        sessionId: res.data.session_id,
      })

      if (error.message) {
        showErrorMessageToast(error.message)
      }

      setIsProcessing(false)
      return
    }

    if (res.type === 'error' && res.status === 403) {
      showErrorMessageToast('You must be an admin or superadmin to edit the payment method.')
      setIsProcessing(false)
      return
    }

    setIsProcessing(false)
    showErrorMessageToast('We encountered an error.  Try again.')
    reportError(new Error('Error creating stripe checkout session'), { severity: 'error' })
  }

  return {
    isProcessing,
    redirectToStripe,
  }
}
